<template>
    <div>
        <div v-for="i in list" :key="i">
            <div @click="goRoom(i)">进入房间--->{{i}}</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            list: [999, 888 ,777, 3728,49234,245465,223432,34345,843442],

        }
    },
    mounted(){
        
    },
    methods: {
        goRoom(id) {
            this.openNewPage(`/onLineMeeting/${id}`, true)
        },
    }
}
</script>

<style lang="scss" scoped>
.onLineMeeting{
    background: #000000;
    position: absolute;
    width:100%;
    height: calc(100% - 118px - 60px)
}
.play-stream{
    width:20%;
    height: 100%;
    overflow-y: auto;
}
</style>